import { PropertyListingTiles } from "../../../PropertyListingTiles";
import { SectionHeader } from "../../../SectionHeader";

import { useHasPropertyListingsQuery } from "./HasPropertyListings.query";
import * as styles from "./PropertyListings.styles";

interface Props {
  listingAgentId: string;
}

const PropertyListings = ({ listingAgentId }: Props) => {
  const { data, loading } = useHasPropertyListingsQuery({
    variables: {
      filter: {
        listingAgentIds: [listingAgentId],
      },
    },
  });

  if (loading || (data?.propertyListings?.length || 0) <= 0) return null;

  return (
    <div css={styles.listingsContainer} className="container">
      <SectionHeader text="My Listings" />
      <PropertyListingTiles listingAgentIds={[listingAgentId]} />
    </div>
  );
};

export { PropertyListings };
